import React, { useEffect, useState } from 'react'

import ModalBlank from './ModalBlank'
import { getCookie, setCookies } from 'cookies-next'
import { cookies_domain_name } from 'constant/url'

function WhatsNew() {
  const [newsModalOpen, setNewsModalOpen] = useState(false)

  useEffect(() => {
    setNewsModalOpen(true)
  }, [0])

  return (
    <div>
      <ModalBlank id="news-modal" modalOpen={newsModalOpen} setModalOpen={setNewsModalOpen}>
        <div className="px-10 py-10 space-y-8 rounded-md">
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-2xl font-semibold text-gray-800 text-center">
              This account was suspended due to late payments.
            </div>
          </div>
          {/* Modal content */}
          <div className="  text-justify">
            <div className="space-y-8">
              <div className="text-sm space-y-3">
                <p className="flex items-start justify-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 576 1000
                    "
                    fill="#34d399"
                  >
                    <path
                      d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V299.6L289.3 
394.3C281.1 402.5 275.3 412.8 272.5 424.1L257.4 484.2C255.1 493.6 255.7 503.2 258.8 
512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM564.1 250.1C579.8 265.7 579.8 
291 564.1 306.7L534.7 336.1L463.8 265.1L493.2 235.7C508.8 220.1 534.1 220.1 549.8 235.7L564.1 
250.1zM311.9 416.1L441.1 287.8L512.1 358.7L382.9 487.9C378.8 492 373.6 494.9 368 496.3L307.9 
511.4C302.4 512.7 296.7 511.1 292.7 507.2C288.7 503.2 287.1 497.4 288.5 491.1L303.5 431.8C304.9 
426.2 307.8 421.1 311.9 416.1V416.1z"
                    />
                  </svg>
                  <span>
                    To reactivate your account, please pay all overdue invoices. Due the 24-hour
                    reactivate period. ignore this message.
                  </span>
                </p>
              </div>
              <div>
                <p className="text-sm text-bold">
                  For more questions,
                  <a
                    className="text-primary underline ml-2"
                    href="https://tradly.app/support"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Contact us
                  </a>
                  . Please ensure that you have paid all unpaid invoices to resume the service.
                </p>
              </div>
            </div>
          </div>
          {/* Modal footer */}
          <div className="mt-2 flex flex-wrap justify-center space-x-2">
            <button
              className="btn-sm bg-primary text-white"
              onClick={(e) => {
                e.stopPropagation()
                // setNewsModalOpen(false)
                window.open('https://tradly.app/workspace/plans')
              }}
            >
              Pay Invoices
            </button>
          </div>
        </div>
      </ModalBlank>
    </div>
  )
}

export default WhatsNew
